<div class='configuration-planning-tab1-part'>
	This is configuration-planning tab 1
</div>